<div class="pro-card dashboard-card">
  <div class="dashboard-card-header">
    <a [routerLink]="headerRouteLink">
      <h2 class="pro-card-title">{{ title }}</h2>
    </a>
    @if (total) {
      <span class="count">{{ total }}</span>
    }
  </div>
  <div class="dashboard-card-content">
    @if (!loading;) {
      @if (listData && listData.length > 0) {
        @for (info of listData | slice : 0 : limitItems; track info; let i = $index) {
          <app-card-dashboard-item
            [infoContent]="info.list ? info.list : []"
            [statusContent]="info.status ? info.status : []"
            [flex]="modeFlex"
            [badgeSize]="modeBadge"
            (goToDetail)="onGoDetail(info.id)"
            />
        }
      } @else {
        <div class="pro-card-empty">
          There are no {{ title }} to display
        </div>
      }
    }

    @if (loading) {
      <div class="pro-card-empty" >
        <app-loader />
      </div>
    }
  </div>


</div>
